define([
	"dojo/_base/declare",
	"dojo/store/Memory",
	"csi/config",
	"csi/locale",
	"csi/xml",
	"./PasteForm"
], function(declare,Memory,config,locale,xml,PasteForm) {

	var OP = "SizeChartPasteOperation";
	var INCREMENTVALUES = "SizeChartPasteIncrementValues";
	var NNAME = "SizeChartPasteNameIndex";
	var ASIZE = "SizeChartPasteSizeAttr";
	var NTOL = "SizeChartPasteToleranceIndex";
	var EXP1 = "validValue('SizeChartPasteData')";
	var EXP2 = "!" + EXP1;

	return declare(PasteForm, {
		_hideExpressions: {
			SizeChartPasteData: EXP1,
			SizeChartPasteOperation: EXP2,
			SizeChartPasteUnits: EXP2,
			SizeChartPasteDimensionIndex: EXP2,
			SizeChartPasteDimensionAttr: EXP2,
			SizeChartPasteNameIndex: EXP2,
			SizeChartPasteSizeAttr: EXP2,
			SizeChartPasteToleranceIndex: EXP2,
			SizeChartPasteIncrementValues: EXP2
		},

		// Memory: stores for selecting indices in pasted data
		_tolStore: null,

		getFieldStore: function(/*Field*/field, /*String*/value) {
			// summary: return stores for fields
			switch(field.m_name) {
				case ASIZE:	return this._getAttributeStore("ProductSize");
				case NNAME: return this._nameStore || this._dummyStore;
				case NTOL:  return this._tolStore  || this._dummyStore;

				case OP: {
					// see if dimension list is locked.  if so, don't provide "Replace" as an option
					var data = [
						{id: "0", name: locale.resource("SizeChartPasteOperationMerge")},
						{id: "1", name: locale.resource("SizeChartPasteOperationAppend")}
						];

					var sizeChart = this.cacheView.getNode(this.cacheView.getNode(this.urlRoot).__Parent__);
					if (!config.getNodeSetting(sizeChart, "LockShapeDimensionList")) {
						data.push({id: "2", name: locale.resource("SizeChartPasteOperationReplace")});
					}

					return new Memory({
						data:data
					});
				};

				case INCREMENTVALUES: {
					return new Memory({
						data: [
							{id: "0", name: locale.resource("SizeChartPasteIncrementActualSizeRange")},
							{id: "1", name: locale.resource("SizeChartPasteIncrementBaseSizeOnly")}
						]
					});
				};
			}

			return this.inherited(arguments);
		},

		_createStoresForIndexFields: function(/*Map*/colsByIndex) {
			// Called by _onWatchData() to create stores for index-type fields
			this.inherited(arguments);
			this._nameStore = this._createStoreForIndexField(NNAME, colsByIndex, true);
			this._tolStore = this._createStoreForIndexField(NTOL, colsByIndex, false);
		},

		_resolveView: function() {
			// summary: set initial values for fields
			this.addDefaultValue(OP, "0");
			this.addDefaultValue(this.UNITS, this._getUnitsDefaultValue());
			this.addDefaultValue(this.ADIM, xml.ATTR_NAME);
			this.addDefaultValue(ASIZE, xml.ATTR_NAME);
			this.addDefaultValue(INCREMENTVALUES, "0");
			this.inherited(arguments);
		}
	});
});